module.exports = __webpack_public_path__ + "media/images/clearbanc-bg-1cf7433633d7efd22bbd7c281a7ddef9.svg";